// src/beta/store/settings.ts
import { create } from 'zustand';

export type OrientationLock = 'landscape' | 'auto';

interface BetaSettings {
  idleTimeoutMs: number;
  orientationLock: OrientationLock;
  setIdleTimeoutMs: (ms: number) => void;
  setOrientationLock: (lock: OrientationLock) => void;
}

export const useBetaSettingsStore = create<BetaSettings>((set) => ({
  idleTimeoutMs: 20_000,
  orientationLock: 'landscape',
  setIdleTimeoutMs: (idleTimeoutMs) => set({ idleTimeoutMs }),
  setOrientationLock: (orientationLock) => set({ orientationLock }),
}));
